<script>
    import {fade} from 'svelte/transition';
    import user from "../stores/user";
    import R from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Alert from "../stores/alerts";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PasswordControl from "../components/controls/PasswordControl.svelte";

    let username = '';
    let password = '';
    let error = false;

    const login = () => {

        const onSuccess = result => {
            error = false;
            user.setUser(result);
            if (window.location.pathname === '/checkin') {
                window.location.reload();
            } else {
                user.hideLogin();
            }
        }

        const onFailure = err => {
            error = true;
            setFocusTo('login-email');
        };

        R.handle(R.app.login, {username, password}, onSuccess, onFailure);
    }

    setFocusTo('login-email');
</script>

<div class="login-overlay" transition:fade="{{ duration: 100 }}">
<!--    <div class="close-login hidden-sm hidden-xs" on:click={ user.hideLogin }>-->
<!--        <AppIcon icon="x" size="24" strokeWidth="2"/>-->
<!--    </div>-->
    <div class="login-content panel-simple box-shadow rounded">
        <div class="content-left">
            <button class="close-login" on:click={ user.hideLogin }>
                <AppIcon icon="x" size="24" strokeWidth="2"/>
            </button>
            <form on:submit|preventDefault|stopPropagation="{ login }">
                <div class="form-logo mb-4">
                    <img src="/assets/images/logo-rect-green.png" alt="logo">
                </div>
                <h1 class="mb-0">Sign in</h1>
                <p class="mb-4">
                    Not a member? <button class="btn-link py-0 px-2" on:click={ user.showSignUp }>Sign up</button>
                </p>
                <div class="form-group">
                    <input type="email" class="form-control" id="login-email" bind:value="{ username }"
                           placeholder="email" required>
                </div>
                <div class="form-group">
                    <PasswordControl bind:value="{ password }" placeholder="password"/>
                </div>
                {#if error}
                    <div class="text-danger text-center fw-semibold mb-4">
                        Your email or password is incorrect
                    </div>
                {/if}
                <button class="btn btn-primary btn-block mb-4">Sign in</button>
                <div class="text-center">
                    <button class="btn btn-link d-block mb-1 mx-auto" on:click={ user.showForgotPassword }>
                        forgot my password
                    </button>
                    <button class="btn btn-link d-block mx-auto" on:click={ user.hideLogin }>
                        close sign in
                    </button>
                </div>
            </form>
        </div>
        <div class="content-right">
            <svg viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice"
                 xmlns="http://www.w3.org/2000/svg" class="graphics circles">
                <g fill="none" stroke="currentColor" stroke-width="100">
                    <circle r="234" cx="196" cy="23"></circle>
                    <circle r="234" cx="790" cy="491"></circle>
                </g>
            </svg>
            <svg viewBox="0 0 220 192" width="220" height="192" fill="none" class="graphics dots">
                <defs>
                    <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20"
                             patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                    </pattern>
                </defs>
                <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
            </svg>
            <div>
                <div class="h1 line-height-1 mb-4">Enorme Hotels Elite Loyalty Membership</div>
<!--                <div>-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore-->
<!--                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut-->
<!--                    aliquip ex ea commodo consequat.-->
<!--                </div>-->
            </div>
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--body-background);
        z-index: 9000;
    }

    .login-content {
        display: flex;
        position: absolute;
        width: 50%;
        min-height: 550px;
        /*max-width: 300px;*/
        /*min-width: 260px;*/
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        overflow: hidden;
    }

    .login-content .content-left {
        position: relative;
        display: flex;
        align-items: center;
        width: 400px;
        padding: 3rem;
    }

    .login-content .content-left form {
        width: 100%;
    }

    .login-content .content-right {
        position: relative;
        display: flex;
        align-items: center;
        width: calc(100% - 400px);
        color: #807f7d;
        background: #000;
        padding: 5rem;
    }

    .login-content .content-right .graphics {
        position: absolute;
        opacity: 0.1;
        color: #ccc;
    }

    .login-content .content-right .circles {
        left: 0;
    }

    .login-content .content-right .dots {
        top: -100px;
        right: -100px;
    }

    .login-content .content-right .h1 {
        color: #D4B275;
    }

    .close-login {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 35px;
        padding: 10px;
        line-height: 1;
        border-radius: 50%;
        border: none;
        background: transparent;
    }
    .close-login:hover {
        color: #000;
        background: #ebebeb;
    }

    @media (max-width: 767px) {
        .login-content {
            width: 95%;
            min-height: unset;
        }

        .login-content .content-left {
            padding: 2rem;
        }

        .login-content .content-right {
            display: none;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .login-content {
            width: 99%;
        }

        .login-content .content-left {
            width: 360px;
        }

        .login-content .content-right {
            width: calc(100% - 360px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .login-content {
            width: 97%;
        }
    }

    @media (min-width: 1200px) and (max-width: 1900px) {
        .login-content {
            width: 70%;
        }
    }
</style>